import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import { useTrans } from 'hooks'
import { FormField, FormRadio } from 'react-components/atoms'
import { AreaPersonaleEditCard } from 'react-components/molecules'

import { REGISTRAZIONE } from 'utils/endpoint'
import { fetchUtente } from 'containers/utente'
import { useDispatch, useSelector } from 'react-redux'
import { api, checkboxMapping } from 'utils'

const AreaPersonaleConoscereProfiloEditCard = props => {
  const { utente } = useSelector(state => state.utente)
  const dispatch = useDispatch()

  const t = useTrans()
  const [editMode, setEditMode] = useState(false)

  return (
    <Formik
      initialValues={{
        flag_pubblico: checkboxMapping[utente?.flag_pubblico] || '0',
      }}
      onSubmit={async (values, { resetForm }) => {
        await api.post(REGISTRAZIONE + 'edit_pubblico/', { ...values })
        dispatch(fetchUtente())
        resetForm()
        setEditMode(false)
      }}
      enableReinitialize
    >
      {({ values, handleChange, handleSubmit }) => (
        <Form>
          <AreaPersonaleEditCard
            title={t('Vuoi rendere il tuo profilo pubblico e visibile agli altri utenti?')}
            description={t(
              'Consenti ad altri utenti di visualizzare le raccolte e gli articoli che crei in qualità di autore.'
            )}
            className="area-personale-conoscere-profilo-edit-card"
            editMode={editMode}
            setEditMode={setEditMode}
            onSubmit={() => handleSubmit()}
          >
            <FormField>
              <FormRadio
                id="conoscere-pubblico"
                name="flag_pubblico"
                value={editMode ? values.flag_pubblico : checkboxMapping[utente.flag_pubblico]}
                options={[
                  {
                    value: '1',
                    label: 'Si, rendere il mio profilo pubblico',
                    disabled: !editMode && checkboxMapping[utente.flag_pubblico] !== '1',
                  },
                  {
                    value: '0',
                    label: 'No, voglio mantenere il mio profilo privato',
                    disabled: !editMode && checkboxMapping[utente.flag_pubblico] !== '0',
                  },
                ]}
                readOnly={!editMode}
                onChange={handleChange}
              />
            </FormField>
          </AreaPersonaleEditCard>
        </Form>
      )}
    </Formik>
  )
}

export default AreaPersonaleConoscereProfiloEditCard
